import React from 'react';

const ControlsFlowStatements = function () {
    return (
        <block type="controls_flow_statements"></block>
    )
};

export default ControlsFlowStatements;